/**
 * The mark, in one place.
 *
 * It was drawn twice before — once in the sign-in page, once in the
 * landing markup — and the two copies had already drifted into a
 * `<symbol>` whose nested viewBox cropped the bird. One definition
 * cannot drift from itself.
 *
 * The identity fixes two rules and both live here: the mark is flat,
 * a single colour, and it is never cropped. `overflow: visible` in
 * the stylesheet is what keeps the second rule true when a parent
 * gives it less room than it asked for.
 */
export function Raven({ className = 'raven' }: { className?: string }) {
  return (
    <svg viewBox="10 14 140 91" className={className} aria-hidden="true" focusable="false">
      <path
        fillRule="evenodd"
        d="M144 54 C137 46 115 36 90 30 C80 26 66 17 52 21 C34 26 19 40 16 57 C13 74 26 92 50 99 C44 85 42 72 51 64 C57 58 64 53 74 49 C96 46 125 50 144 54 Z M59.8 34 a3.8 3.8 0 1 0 -7.6 0 a3.8 3.8 0 1 0 7.6 0 Z"
      />
    </svg>
  );
}
